import { render, staticRenderFns } from "./Y02L.vue?vue&type=template&id=50cf8f6c&scoped=true"
import script from "./Y02L.vue?vue&type=script&lang=js"
export * from "./Y02L.vue?vue&type=script&lang=js"
import style0 from "./Y02L.vue?vue&type=style&index=0&id=50cf8f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf8f6c",
  null
  
)

export default component.exports